export const getFAQCATEGORYDATA = (t: (key: string) => string) => [
  {
    key: 'get-started',
    name: t('faq_categories_detailed.get-started.name'),
    description: t('faq_categories_detailed.get-started.description'),
    metadata: {
      title: t('faq_categories_detailed.get-started.metadata.title'),
      description: t(
        'faq_categories_detailed.get-started.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q1.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q1.answer'),
      },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q2.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q2.answer'),
      },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q3.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q3.answer'),
      },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q4.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q4.answer'),
      },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q5.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q5.answer'),
      },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q6.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q6.answer'),
      },
      // {
      //   question: t(
      //     'faq_categories_detailed.get-started.questions.q7.question'
      //   ),
      //   answer: t('faq_categories_detailed.get-started.questions.q7.answer'),
      // },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q8.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q8.answer'),
      },
      {
        question: t(
          'faq_categories_detailed.get-started.questions.q9.question'
        ),
        answer: t('faq_categories_detailed.get-started.questions.q9.answer'),
      },
    ],
  },
  {
    key: 'features-and-tools',
    name: t('faq_categories_detailed.features-and-tools.name'),
    description: t('faq_categories_detailed.features-and-tools.description'),
    metadata: {
      title: t('faq_categories_detailed.features-and-tools.metadata.title'),
      description: t(
        'faq_categories_detailed.features-and-tools.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q1.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q1.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q2.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q2.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q3.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q3.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q4.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q4.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q5.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q5.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q6.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q6.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.features-and-tools.questions.q7.question'
        ),
        answer: t(
          'faq_categories_detailed.features-and-tools.questions.q7.answer'
        ),
      },
    ],
  },
  {
    key: 'pricing-and-plans',
    name: t('faq_categories_detailed.pricing-and-plans.name'),
    description: t('faq_categories_detailed.pricing-and-plans.description'),
    metadata: {
      title: t('faq_categories_detailed.pricing-and-plans.metadata.title'),
      description: t(
        'faq_categories_detailed.pricing-and-plans.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q1.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q1.answer'
        ),
      },
      // {
      //   question: t(
      //     'faq_categories_detailed.pricing-and-plans.questions.q2.question'
      //   ),
      //   answer: t(
      //     'faq_categories_detailed.pricing-and-plans.questions.q2.answer'
      //   ),
      // },
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q3.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q3.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q4.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q4.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q5.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q5.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q6.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q6.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q7.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q7.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.pricing-and-plans.questions.q8.question'
        ),
        answer: t(
          'faq_categories_detailed.pricing-and-plans.questions.q8.answer'
        ),
      },
    ],
  },
  {
    key: 'security-and-privacy',
    name: t('faq_categories_detailed.security-and-privacy.name'),
    description: t('faq_categories_detailed.security-and-privacy.description'),
    metadata: {
      title: t('faq_categories_detailed.security-and-privacy.metadata.title'),
      description: t(
        'faq_categories_detailed.security-and-privacy.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q1.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q1.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q2.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q2.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q3.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q3.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q4.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q4.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q5.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q5.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q6.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q6.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q7.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q7.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q8.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q8.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.security-and-privacy.questions.q9.question'
        ),
        answer: t(
          'faq_categories_detailed.security-and-privacy.questions.q9.answer'
        ),
      },
    ],
  },
  {
    key: 'file-management',
    name: t('faq_categories_detailed.file-management.name'),
    description: t('faq_categories_detailed.file-management.description'),
    metadata: {
      title: t('faq_categories_detailed.file-management.metadata.title'),
      description: t(
        'faq_categories_detailed.file-management.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.file-management.questions.q1.question'
        ),
        answer: t(
          'faq_categories_detailed.file-management.questions.q1.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.file-management.questions.q2.question'
        ),
        answer: t(
          'faq_categories_detailed.file-management.questions.q2.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.file-management.questions.q3.question'
        ),
        answer: t(
          'faq_categories_detailed.file-management.questions.q3.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.file-management.questions.q4.question'
        ),
        answer: t(
          'faq_categories_detailed.file-management.questions.q4.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.file-management.questions.q5.question'
        ),
        answer: t(
          'faq_categories_detailed.file-management.questions.q5.answer'
        ),
      },
    ],
  },
  {
    key: 'troubleshooting-and-support',
    name: t('faq_categories_detailed.troubleshooting-and-support.name'),
    description: t(
      'faq_categories_detailed.troubleshooting-and-support.description'
    ),
    metadata: {
      title: t(
        'faq_categories_detailed.troubleshooting-and-support.metadata.title'
      ),
      description: t(
        'faq_categories_detailed.troubleshooting-and-support.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q1.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q1.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q2.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q2.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q3.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q3.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q4.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q4.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q5.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q5.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q6.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q6.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q7.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q7.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q8.question'
        ),
        answer: t(
          'faq_categories_detailed.troubleshooting-and-support.questions.q8.answer'
        ),
      },
    ],
  },
  {
    key: 'membership-and-account',
    name: t('faq_categories_detailed.membership-and-account.name'),
    description: t(
      'faq_categories_detailed.membership-and-account.description'
    ),
    metadata: {
      title: t('faq_categories_detailed.membership-and-account.metadata.title'),
      description: t(
        'faq_categories_detailed.membership-and-account.metadata.description'
      ),
    },
    questions: [
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q1.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q1.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q2.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q2.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q3.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q3.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q4.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q4.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q5.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q5.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q6.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q6.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q7.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q7.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q8.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q8.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q9.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q9.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q10.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q10.answer'
        ),
      },
      {
        question: t(
          'faq_categories_detailed.membership-and-account.questions.q11.question'
        ),
        answer: t(
          'faq_categories_detailed.membership-and-account.questions.q11.answer'
        ),
      },
    ],
  },
];
